<script lang="ts" setup>
export type TypoType = 'ext'

export interface TypoProps {
    type?: TypoType
}

const props = defineProps<TypoProps>()
</script>
<template>
  <div
    class="typography"
    :class="{
      [`typography-${props.type}`]: props.type,
    }"
  >
    <slot />
  </div>
</template>
<style>
@import './Typo.vars.scss';
</style>
<style lang="scss">
@import './Typo.scss';
</style>
